import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FiMap, FiMail, FiPhone } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleScrollTo = (e, id) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-950 text-stone-300 py-12 border-t border-stone-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <SafeIcon icon={FiMap} className="text-2xl text-brand-500" />
              <span className="font-serif font-bold text-xl tracking-tight text-white">
                Land<span className="text-brand-500">Quick</span>
              </span>
            </div>
            <p className="text-stone-400 max-w-sm mb-6">
              Professional land buyers dedicated to providing a transparent, fast, and hassle-free selling experience for property owners nationwide.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><button onClick={(e) => handleScrollTo(e, 'how-it-works')} className="hover:text-brand-400 transition-colors">How It Works</button></li>
              <li><button onClick={(e) => handleScrollTo(e, 'benefits')} className="hover:text-brand-400 transition-colors">Benefits</button></li>
              <li><a href="tel:2512431403" className="hover:text-brand-400 transition-colors">Call/Text Us</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a href="tel:2512431403" className="flex items-center gap-3 hover:text-brand-400 transition-colors">
                  <SafeIcon icon={FiPhone} className="text-brand-500" />
                  <span>(251) 243-1403</span>
                </a>
              </li>
              <li>
                <a href="mailto:stu@landquick.net" className="flex items-center gap-3 hover:text-brand-400 transition-colors">
                  <SafeIcon icon={FiMail} className="text-brand-500" />
                  <span>stu@landquick.net</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-stone-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-stone-500">
          <p>&copy; {new Date().getFullYear()} Land Quick. All rights reserved.</p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}